// extracted by mini-css-extract-plugin
export default {"root":"QtyInput-root-2_o","label":"QtyInput-label-2vk"};